import { selection } from './selection';
export { createFakeParagraph, findFakeParaPosForNodeSelection, findFakeParaPosForTextSelection, findFakeParaPosForCodeBlock, findFakeParaPosClosestToPos, } from './commands';
export const Selection = (builder) => {
    builder.addPlugin(selection);
};
